export const ALL_UNIVERSITIES = [
  "Московский государственный университет имени М.В.Ломоносова",
  "Национальный исследовательский ядерный университет «МИФИ»",
  "Московский физико-технический институт (национальный исследовательский университет)",
  "Национальный исследовательский университет «Высшая школа экономики»",
  "Санкт-Петербургский государственный университет",
  "Национальный исследовательский Томский государственный университет",
  "Новосибирский национальный исследовательский государственный университет НГУ",
  "Казанский (Приволжский) федеральный университет",
  "Российский университет дружбы народов имени Патриса Лумубы",
  "Национальный исследовательский технологический университет \"МИСИС\"",
  "Уральский федеральный университет имени первого Президента России Б.Н.Ельцина",
  "Московский государственный технический университет имени Н.Э.Баумана",
  "Национальный исследовательский Томский политехнический университет",
  "Санкт-Петербургский политехнический университет Петра Великого",
  "Национальный исследовательский университет ИТМО",
  "Южный федеральный университет",
  "Первый Московский государственный медицинский университет имени И.М. Сеченова",
  "Сибирский федеральный университет",
  "Российская академия народного хозяйства и государственной службы при Президенте РФ",
  "Национальный исследовательский университет «Московский Энергетический Институт»",
  "Белгородский государственный национальный исследовательский университет",
  "Дальневосточный федеральный университет",
  "Российский экономический университет имени Г.В.Плеханова",
  "Финансовый Университет при Правительстве РФ",
  "Российский национальный исследовательский медицинский университет имени Н.И.Пирогова",
  "Московский авиационный институт (НИУ)",
  "Нижегородский государственный университет имени Н.И.Лобачевского (НИУ)",
  "Национальный исследовательский Южно-Уральский государственный университет",
  "Балтийский федеральный университет имени Иммануила Канта",
  "Санкт-Петербургский горный университет императрицы Екатерины II",
  "Национальный исследовательский Мордовский государственный университет имени Н.П.Огарева",
  "Северо-Восточный федеральный университет имени М.К.Аммосова",
  "Северо-Кавказский федеральный университет",
  "Российский химико-технологический университет имени Д.И.Менделеева",
  "Новосибирский государственный технический университет",
  "Саратовский государственный университет имени Н.Г.Чернышевского",
  "Московский государственный строительный университет (НИУ)",
  "МИРЭА - Российский технологический университет",
  "Петрозаводский государственный университет",
  "Самарский национальный исследовательский университет имени академика С.П.Королева",
  "Уфимский государственный нефтяной технический университет",
  "Национальный исследовательский университет «МИЭТ»",
  "Воронежский государственный университет",
  "Московский педагогический государственный университет",
  "Российский государственный педагогический университет имени А.И.Герцена",
  "Санкт-Петербургский государственный электротехнический университет \"ЛЭТИ\" имени В.И.Ульянова (Ленина)",
  "Иркутский национальный исследовательский технический университет",
  "Казанский национальный исследовательский технический университет имени А.Н.Туполева (КАИ)",
  "Донской государственный технический университет",
  "Казанский национальный исследовательский технологический университет (КХТИ)",
  "Пермский национальный исследовательский политехнический университет",
  "Иркутский государственный университет",
  "Томский государственный университет систем управления и радиоэлектроники",
  "Самарский государственный технический университет",
  "Кабардино-Балкарский государственный университет имени Х.М.Бербекова",
  "Российский государственный университет нефти и газа имени И.М.Губкина",
  "Московский государственный технологический университет «Станкин»",
  "Тюменский индустриальный университет",
  "Башкирский государственный медицинский университет",
  "Крымский федеральный университет имени В.И.Вернадского",
  "Уфимский университет науки и технологий",
  "Российский университет медицины (Московский государственный медико-стоматологический университет имени А.И.Евдокимова)",
  "Пермский государственный национальный исследовательский университет",
  "Северо-Западный государственный медицинский университет имени И.И.Мечникова",
  "Сибирский государственный медицинский университет",
  "Тамбовский государственный технический университет",
  "Санкт-Петербургский государственный экономический университет",
  "Государственный университет просвещения",
  "Нижегородский государственный технический университет имени Р.Е.Алексеева",
  "Российский университет транспорта (МИИТ)",
  "Тюменский государственный университет",
  "Белгородский государственный технологический университет имени В.Г.Шухова",
  "Северный (Арктический) федеральный университет имени М.В.Ломоносова",
  "Казанский государственный медицинский университет",
  "Кубанский государственный университет",
  "Омский государственный технический университет",
  "Российский государственный аграрный университет – МСХА имени К.А.Тимирязева",
  "Саратовский государственный технический университет имени Ю.А.Гагарина",
  "Владимирский государственный университет имени Александра Григорьевича и Николая Григорьевича Столетовых",
  "Московский политехнический университет",
  "Сибирский государственный университет науки и технологий имени академика М.Ф.Решетнева",
  "Рязанский государственный медицинский университет имени академика И.П.Павлова",
  "Санкт-Петербургский государственный морской технический университет",
  "Первый Санкт-Петербургский государственный медицинский университет имени академика И.П.Павлова",
  "Государственный университет управления",
  "Российский государственный гуманитарный университет",
  "Санкт-Петербургский государственный педиатрический медицинский университет",
  "Санкт-Петербургский государственный университет промышленных технологий и дизайна",
  "Московский государственный университет технологий и управления имени К.Г.Разумовского (Первый казачий университет)",
  "Пензенский государственный университет",
  "Ставропольский государственный аграрный университет",
  "Кубанский государственный аграрный университет имени И.Т.Трубилина",
  "Вятский государственный университет",
  "Омский государственный аграрный университет имени П.А.Столыпина",
  "Тихоокеанский государственный университет",
  "Томский государственный педагогический университет",
  "Южно-Российский государственный политехнический университет имени М.И.Платова (НПИ)",
  "Петербургский государственный университет путей сообщения Императора Александра I",
  "Санкт-Петербургский государственный технологический институт (технический университет)",
  "Волгоградский государственный технический университет",
  "Ульяновский государственный университет",
  "Казанский государственный энергетический университет",
  "Российский государственный университет имени А.Н.Косыгина (Технологии. Дизайн. Искусство)",
  "Адыгейский государственный университет",
  "Владивостокский государственный университет (ВГУЭС)",
  "Санкт-Петербургский государственный университет аэрокосмического приборостроения",
  "Университет Синергия",
  "Московский государственный юридический университет имени О.Е.Кутафина (МГЮА)",
  "Северный государственный медицинский университет",
  "Новосибирский государственный медицинский университет",
  "Российский биотехнологический университет",
  "Санкт-Петербургский государственный университет телекоммуникаций имени профессора М.А.Бонч-Бруевича",
  "Санкт-Петербургский национальный исследовательский академический университет РАН (Алфёровский университет)",
  "Юго-Западный государственный университет",
  "Российский новый университет",
  "Новгородский государственный университет имени Ярослава Мудрого",
  "Томский государственный архитектурно-строительный университет",
  "Кемеровский государственный университет",
  "Чеченский государственный университет имени А.А.Кадырова",
  "Орловский государственный университет имени И.С.Тургенева",
  "Саратовский государственный медицинский университет имени В.И.Разумовского",
  "Ярославский государственный университет имени П.Г.Демидова",
  "Кубанский государственный технологический университет",
  "Волгоградский государственный университет",
  "Курский государственный медицинский университет",
  "Новосибирский государственный педагогический университет",
  "Омский государственный университет имени Ф.М.Достоевского",
  "Самарский государственный медицинский университет",
  "Тульский государственный университет",
  "Воронежский государственный технический университет",
  "Уральский государственный аграрный университет",
  "Ижевский государственный технический университет имени М.Т.Калашникова",
  "Марийский государственный университет",
  "Московский городской педагогический университет",
  "Московский технический университет связи и информатики",
  "Московский университет имени С.Ю.Витте",
  "Самарский государственный экономический университет",
  "Ивановский государственный университет",
  "Тамбовский государственный университет имени Г.Р.Державина",
  "Калужский государственный университет имени К.Э.Циолковского",
  "Московский автомобильно-дорожный государственный технический университет",
  "Оренбургский государственный университет",
  "Российский государственный геологоразведочный университет имени Серго Орджоникидзе",
  "Дагестанский государственный университет",
  "Магнитогорский государственный технический университет имени Г.И.Носова",
  "Санкт-Петербургский государственный аграрный университет",
  "Кубанский государственный медицинский университет",
  "Пермский государственный медицинский университет имени академика Е.А.Вагнера",
  "Нижегородский государственный педагогический университет имени Козьмы Минина",
  "Челябинский государственный университет",
  "Чувашский государственный университет имени И.Н.Ульянова",
  "Поволжский государственный технологический университет Волгатех",
  "Тольяттинский государственный университет",
  "Байкальский государственный университет",
  "Приволжский исследовательский медицинский университет (НижГМА)",
  "Сибирский государственный университет геосистем и технологий",
  "Московский институт психоанализа",
  "Санкт-Петербургский государственный архитектурно-строительный университет",
  "Ивановский государственный химико-технологический университет",
  "Московская государственная академия ветеринарной медицины и биотехнологий - МВА имени К.И.Скрябина",
  "Новосибирский государственный университет экономики и управления «НИНХ»",
  "Санкт-Петербургский государственный химико-фармацевтический университет",
  "Калмыцкий государственный университет имени Б.Б.Городовикова",
  "Пензенский государственный университет архитектуры и строительства",
  "Уральский государственный горный университет",
  "Астраханский государственный университет имени В.Н.Татищева",
  "Государственный университет \"Дубна\"",
  "Пятигорский государственный университет",
  "Севастопольский государственный университет",
  "Тверской государственный университет",
  "Московский государственный лингвистический университет",
  "Алтайский государственный технический университет имени И.И.Ползунова",
  "Башкирский государственный аграрный университет",
  "Ростовский государственный университет путей сообщения",
  "Волгоградский государственный медицинский университет",
  "Воронежский государственный университет инженерных технологий",
  "Амурская государственная медицинская академия",
  "Башкирский государственный педагогический университет имени М.Акмуллы",
  "Забайкальский государственный университет",
  "Красноярский государственный аграрный университет",
  "Оренбургский государственный медицинский университет",
  "Тюменский государственный медицинский университет",
  "Дальневосточный государственный медицинский университет",
  "Российский государственный гидрометеорологический университет",
  "Тверской государственный технический университет",
  "Уральский государственный экономический университет",
  "Балтийский государственный технический университет \"Военмех\" имени Д.Ф.Устинова",
  "Дагестанский государственный технический университет",
  "Курский государственный университет",
  "Новосибирский государственный архитектурно-строительный университет Сибстрин",
  "Иркутский государственный университет путей сообщения",
  "Приамурский государственный университет имени Шолом-Алейхема",
  "Псковский государственный университет",
  "Бурятский государственный университет имени Доржи Банзарова",
  "Комсомольский-на-Амуре государственный университет",
  "Омский государственный университет путей сообщения",
  "Российский государственный социальный университет",
  "Саратовский государственный университет генетики, биотехнологии и инженерии имени Н.И.Вавилова (Вавиловский университет)",
  "Югорский государственный университет",
  "Омский государственный педагогический университет",
  "Удмуртский государственный университет",
  "Ивановский государственный энергетический университет имени В.И.Ленина",
  "Красноярский государственный медицинский университет имени профессора В.Ф.Войно-Ясенецкого",
  "Московский государственный психолого-педагогический университет",
  "Уральский государственный юридический университет имени В.Ф.Яковлева",
  "Астраханский государственный медицинский университет",
  "Астраханский государственный технический университет",
  "Брянский государственный университет имени академика И.Г.Петровского",
  "Государственный университет морского и речного флота имени адмирала С.О.Макарова",
  "Казанский государственный архитектурно-строительный университет",
  "Казанский инновационный университет имени В.Г.Тимирясова",
  "Ухтинский государственный технический университет",
  "Череповецкий государственный университет",
  "Амурский государственный университет",
  "Новосибирский государственный аграрный университет",
  "Орловский государственный аграрный университет имени Н.В.Парахина",
  "Рязанский государственный радиотехнический университет имени В.Ф.Уткина",
  "Хакасский государственный университет имени Н.Ф.Катанова",
  "Государственный гуманитарно-технологический университет",
  "Донской государственный аграрный университет",
  "Уральский государственный университет путей сообщения",
  "Государственный университет по землеустройству",
  "Кировский государственный медицинский университет",
  "Рязанский государственный университет имени С.А.Есенина",
  "Уральский государственный медицинский университет",
  "Алтайский государственный медицинский университет",
  "Альметьевский государственный технологический университет \"Высшая школа нефти\"",
  "Дальневосточный государственный университет путей сообщения",
  "Елецкий государственный университет имени И.А.Бунина",
  "Ростовский государственный экономический университет (РИНХ)",
  "Белгородский государственный аграрный университет имени В.Я.Горина",
  "Кузбасский государственный технический университет имени Т.Ф.Горбачева",
  "Волгоградский государственный аграрный университет",
  "Приморский государственный аграрно-технологический университет (Приморская государственная сельскохозяйственная академия)",
  "Самарский государственный университет путей сообщения",
  "Грозненский государственный нефтяной технический университет имени академика М.Д.Миллионщикова",
  "Красноярский государственный педагогический университет имени В.П.Астафьева",
  "Нижегородский государственный архитектурно-строительный университет",
  "Рязанский государственный агротехнологический университет имени П.А.Костычева",
  "Ижевская государственная медицинская академия",
  "Костромской государственный университет",
  "Тверской государственный медицинский университет",
  "Благовещенский государственный педагогический университет",
  "Государственный социально-гуманитарный университет",
  "Пензенский государственный технологический университет",
  "Ульяновский государственный педагогический университет имени И.Н.Ульянова",
  "Ярославский государственный технический университет",
  "Алтайский государственный педагогический университет",
  "Вологодский государственный университет",
  "Сыктывкарский государственный университет имени Питирима Сорокина",
  "Технологический университет имени дважды Героя Советского Союза, летчика-космонавта А.А.Леонова",
  "Ульяновский государственный технический университет",
  "Ярославский государственный педагогический университет имени К.Д.Ушинского",
  "Ивановский государственный медицинский университет",
  "Омский государственный медицинский университет",
  "Смоленский государственный медицинский университет",
  "Казанский государственный аграрный университет",
  "Российский университет кооперации",
  "Тульский государственный педагогический университет имени Л.Н.Толстого",
  "Ярославский государственный медицинский университет",
  "Воронежский государственный аграрный университет имени Императора Петра I",
  "Государственный институт русского языка имени А.С.Пушкина",
  "Майкопский государственный технологический университет",
  "Нижегородский государственный лингвистический университет имени Н.А.Добролюбова",
  "Воронежский государственный лесотехнический университет имени Г.Ф.Морозова",
  "Всероссийский государственный университет юстиции",
  "Мордовский государственный педагогический университет имени М.Е.Евсевьева",
  "Ростовский государственный медицинский университет",
  "Южно-Уральский государственный медицинский университет",
  "Иркутский государственный аграрный университет имени А.А.Ежевского",
  "Тихоокеанский государственный медицинский университет",
  "Воронежский государственный медицинский университет имени Н.Н.Бурденко",
  "Воронежский государственный педагогический университет",
  "Чувашский государственный аграрный университет",
  "Московский архитектурный институт (Государственная академия)",
  "Санкт-Петербургский университет технологий управления и экономики под научно-методическим руководством ООН РАН",
  "Саратовская государственная юридическая академия",
  "Северо-Осетинский государственный университет имени К.Л.Хетагурова",
  "Сибирский государственный автомобильно-дорожный университет",
  "Южно-Уральский государственный аграрный университет",
  "Нижневартовский государственный университет",
  "Дагестанский государственный аграрный университет имени М.М.Джамбулатова",
  "Братский государственный университет",
  "Ленинградский государственный университет имени А.С.Пушкина",
  "Российский государственный университет туризма и сервиса",
  "Санкт-Петербургский государственный лесотехнический университет имени С.М.Кирова",
  "Сибирский государственный университет путей сообщения",
  "Брянский государственный аграрный университет",
  "Сургутский государственный университет",
  "Брянский государственный инженерно-технологический университет",
  "Пермская государственная фармацевтическая академия",
  "Сибирский государственный индустриальный университет",
  "Тувинский государственный университет",
  "Дальневосточный государственный технический рыбохозяйственный университет",
  "Московский государственный университет геодезии и картографии (МИИГАиК)",
  "Брянский государственный технический университет",
  "Волжский государственный университет водного транспорта",
  "Ивановский государственный политехнический университет",
  "Кузбасский государственный аграрный университет имени В.Н.Полецкова",
  "Мурманский арктический университет",
  "Оренбургский государственный педагогический университет",
  "Волгоградский государственный социально-педагогический университет",
  "Смоленский государственный университет",
  "Горно-Алтайский государственный университет",
  "Государственный морской университет имени адмирала Ф.Ф.Ушакова",
  "Пензенский государственный аграрный университет",
  "Бурятская государственная сельскохозяйственная академия имени В.Р.Филиппова",
  "Ставропольский государственный медицинский университет",
  "Липецкий государственный технический университет",
  "Сочинский государственный университет",
  "Курганский государственный университет",
  "Южно-Уральский государственный гуманитарно-педагогический университет (ЧГПУ)",
  "Мичуринский государственный аграрный университет",
  "Курский государственный аграрный университет имени И.И.Иванова",
  "Липецкий государственный педагогический университет имени П.П.Семенова-Тян-Шанского",
  "Горский государственный аграрный университет",
  "Ингушский государственный университет",
  "Пермский государственный гуманитарно-педагогический университет",
  "Поволжский государственный университет сервиса",
  "Сахалинский государственный университет",
  "Дальневосточный государственный аграрный университет",
  "Карачаево-Черкесский государственный университет имени У.Д.Алиева",
  "Нижегородский государственный агротехнологический университет (Нижегородская государственная сельхозакадемия)",
  "Государственный институт экономики, финансов, права и технологий",
  "Калининградский государственный технический университет",
  "Московский финансово-юридический университет МФЮА",
  "Белгородский университет кооперации, экономики и права",
  "Морской государственный университет имени адмирала Г.И.Невельского",
  "Уральский государственный педагогический университет",
  "Государственный аграрный университет Северного Зауралья",
  "Восточно-Сибирский государственный университет технологий и управления",
  "Кабардино-Балкарский государственный аграрный университет имени В.М.Кокова",
  "Московский государственный технический университет гражданской авиации",
  "Новосибирский государственный университет архитектуры, дизайна и искусств имени А.Д.Крячкова (НАрхИ)",
  "Северо-Восточный государственный университет",
  "Алтайский государственный аграрный университет",
  "Арктический государственный агротехнологический университет",
  "Вятский государственный агротехнологический университет",
  "Дагестанский государственный медицинский университет",
  "Сибирский государственный университет телекоммуникаций и информатики",
  "Сургутский государственный педагогический университет",
  "Чувашский государственный педагогический университет имени И.Я.Яковлева",
  "Северо-Кавказский горно-металлургический институт (ГТУ)",
  "Рыбинский государственный авиационный технический университет имени П.А.Соловьева",
  "Российский государственный профессионально-педагогический университет",
  "Ярославский государственный аграрный университет",
  "Верхневолжский государственный агробиотехнологический университет",
  "Ангарский государственный технический университет",
  "Поволжский государственный университет телекоммуникаций и информатики",
  "Самарский государственный социально-педагогический университет",
  "Камчатский государственный университет имени Витуса Беринга",
  "Пермский государственный аграрно-технологический университет имени академика Д.Н.Прянишникова",
  "Нижегородский государственный инженерно-экономический университет",
  "Московская международная академия",
  "Омская гуманитарная академия",
  "Глазовский государственный педагогический институт имени В.Г.Короленко",
  "Национальный медицинский исследовательский центр имени В.А.Алмазова",
  "Московский университет имени А.С.Грибоедова (ИМПЭ)",
  "Институт бизнеса и дизайна",
  "Сибирский университет потребительской кооперации",
  "Армавирский государственный педагогический университет",
  "Камчатский государственный технический университет",
  "Международный банковский институт имени Анатолия Собчака",
  "Северо-Кавказская государственная академия",
  "Амурский гуманитарно-педагогический государственный университет",
  "Русская христианская гуманитарная академия имени Ф.М.Достоевского",
  "Уральский государственный архитектурно-художественный университет",
  "Чеченский государственный педагогический университет",
  "Южный университет (ИУБиП)",
  "Сибирский государственный университет водного транспорта",
  "Московский социально-педагогический институт",
  "Заполярный государственный университет имени Н.М.Федоровского",
  "Московский психолого-социальный университет",
  "Тольяттинская академия управления",
  "Институт международных экономических связей",
  "Университет мировых цивилизаций имени В.В.Жириновского",
  "Московский международный университет",
  "Российский государственный университет народного хозяйства имени В.И.Вернадского",
  "河北师范大学",
  "Hebei Normal University",
];

export const POPULAR_UNIVERSITIES = [
    "Новосибирский национальный исследовательский государственный университет НГУ",
    "Национальный исследовательский университет ИТМО",
    "Hebei Normal University ",
    "Московский физико-технический институт (национальный исследовательский университет)",
    "Национальный исследовательский университет «Высшая школа экономики»",
    "Санкт-Петербургский государственный университет",
    "Национальный исследовательский Томский государственный университет",
    "Казанский (Приволжский) федеральный университет",
    "Российский университет дружбы народов имени Патриса Лумубы",
    "Национальный исследовательский технологический университет \"МИСИС\""
  ];